import { IMAGE_NODE_HEIGHT, IMAGE_NODE_WIDTH } from "../Constants";
import { NodeStore, StoreType } from "./NodeStore";

/**
 * This class represents an image node that displays an image from a given URL.
 * It extends the NodeStore class by adding properties specific to image nodes 
 * while also reusing shared behavior such as positioning and sizing.
 */
export interface ImageNodeArgs {
    x: number;
    y: number;
    title: string;
    url: string;
    width?: number;
    height?: number;
}

/**
 * This method is the constructor for an ImageNodeStore and initializes its 
 * positioning and image source. It sets default dimensions if none are provided.
 * @param args The Object containing the x and y coordinates, image title, image URL, and optional width and height.
 */
export class ImageNodeStore extends NodeStore {
    public title: string;
    public url: string;

    constructor(args: ImageNodeArgs) {
        super();
        this.type = StoreType.Image;
        this.x = args.x;
        this.y = args.y;
        this.title = args.title;
        this.url = args.url;
        this.width = args.width ?? IMAGE_NODE_WIDTH;
        this.height = args.height ?? IMAGE_NODE_HEIGHT;
    }
}